export default __webpack_public_path__ + "static/media/header_box.49f8d1ad.jpg";